module.exports = __webpack_public_path__ + "img/binance.b2e50713.png";